import { FieldValues } from 'react-hook-form'

const cacheByLayout = new Map<
  string,
  Map<string, FieldValues[] | Record<string, unknown>>
>()

export const setRuleCache = (
  layoutUid: string,
  cacheKey: string,
  rows: FieldValues[] | Record<string, unknown>
): void => {
  if (!cacheByLayout.has(layoutUid)) {
    cacheByLayout.set(layoutUid, new Map())
  }
  cacheByLayout.get(layoutUid)!.set(cacheKey, rows)
}

export const getRuleCache = (
  layoutUid: string,
  cacheKey: string
): FieldValues[] | Record<string, unknown> | undefined =>
  cacheByLayout.get(layoutUid)?.get(cacheKey)

export const clearRuleCache = (layoutUid: string): void => {
  cacheByLayout.delete(layoutUid)
}
